import { END_POINTS } from "../constants/urls";
import { CommonBody, CommonResponseType } from "../types/General";
import emptySplitApi from "../utils/rtk";

export const productApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getProduct: builder.query<
      CommonResponseType & { data: any },
      {
        search?: string;
        limit?: number;
        page?: number;
        parentId?: string;
        status?: boolean;
        isBlocked?: boolean;
        isReport?: boolean;
      }
    >({
      query: ({ page, limit, search, isBlocked, status, parentId, isReport }) => ({
        url: `${END_POINTS.getProduct}?page=${page}&limit=${limit}${
          search ? `&search=${search}` : ""
        }${isBlocked ? `&isBlocked=${isBlocked}` : ""}${
          status ? `&status=${status}` : ""
        }${parentId ? `&parentId=${parentId}` : ""}${
          isReport ? `&isReport=${isReport}` : ""
        }`,
        method: "GET",
      }),
    }),
    getProductById: builder.query<CommonResponseType & { data: any }, {}>({
      query: (id) => ({
        url: `${END_POINTS.getProductById}/${id}`,
        method: "GET",
      }),
    }),
    updateProduct: builder.mutation<
      CommonResponseType,
      { body: any; id: any }
    >({
      query: ({ body, id }) => ({
        url: `${END_POINTS.updateProduct}/${id}`,
        method: "PUT",
        body,
      }),
    }),
    deleteProduct: builder.mutation<CommonResponseType, { id: any }>({
      query: ({ id }) => ({
        url: `${END_POINTS.deleteProduct}/${id}`,
        method: "DELETE",
      }),
    }),
  }),
});

export const {
  useLazyGetProductQuery,
  useDeleteProductMutation,
  useUpdateProductMutation,
  useLazyGetProductByIdQuery,
} = productApi;
